export default __webpack_public_path__ + "static/media/img2.06601df5.jpg";